<div class="base-container">
  <div class="flex-flow-wrapper">
    <ng-container *ngTemplateOutlet="cardMap"></ng-container>
    <ng-container *ngTemplateOutlet="cardInfoBox"></ng-container>
  </div>

  <ng-template #cardInfoBox>
    <!-- (Infobox) -->
    <mat-card appearance="outlined" class="model-info-card">
      <mat-card-header>
        <fa-icon
          mat-card-avatar
          [icon]="['far', 'satellite']"
          size="2x"></fa-icon>
        <mat-card-title>{{
          'PRODUCT.SATELLITE.TITLE' | translate
        }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <form>
          <mat-form-field appearance="fill" class="product-select">
            <mat-label>
              {{ 'PRODUCT.SATELLITE.SELECT_PRODUCT_TYPE' | translate }}
            </mat-label>
            <mat-select
              [value]="selectedSatType()"
              (selectionChange)="onChangeSatType($event)">
              @for (satType of satTypes(); track $index) {
                <mat-option [value]="satType">
                  <span
                    [translate]="
                      'PRODUCT.SATELLITE.PRODUCT_TYPES.' + satType
                    "></span>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <br />
          <!-- Timerange Select -->
          <mat-form-field appearance="fill" class="hours-select">
            <mat-label>
              {{ 'PRODUCT.SATELLITE.SELECT_HOURS' | translate }}
            </mat-label>
            <mat-select
              [value]="timeRange()"
              (selectionChange)="onChangeTimeRange($event)">
              @for (hour of [3, 6, 12, 24]; track $index) {
                <mat-option [value]="hour">
                  {{ hour }}
                  <span [translate]="'PRODUCT.SATELLITE.HOURS'"></span>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <br />
          <!-- Speed -->
          <mat-form-field appearance="fill" class="hours-select">
            <mat-label>
              {{ 'PRODUCT.SATELLITE.SELECT_SPEED' | translate }}
            </mat-label>
            <mat-select
              [value]="animationSpeed()"
              (selectionChange)="onChangeSpeed($event)">
              @for (speed of [700, 500, 300]; track $index) {
                <mat-option [value]="speed">
                  <span [translate]="'PRODUCT.SATELLITE.SPEED.' + speed"></span>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </form>
      </mat-card-content>
    </mat-card>
  </ng-template>

  <ng-template #cardMap>
    <mat-card appearance="outlined" class="map-card">
      <mat-card-header>
        <fa-icon
          mat-card-avatar
          [icon]="['far', 'satellite']"
          size="2x"></fa-icon>
        @if (mapDtg.isValid()) {
          <mat-card-title>
            {{
              'PRODUCT.SATELLITE.PRODUCT_TYPES.' + selectedSatType() | translate
            }}
            -
            {{ mapDtg | datex: 'dddd DD.MM.YYYY HH:mm' }}
          </mat-card-title>
        }
        <mat-card-subtitle>
          {{ 'PRODUCT.SATELLITE.TITLE' | translate }}
        </mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <!-- Slider -->
        @let satDataValue = satData();
        @if (satDataValue && satDataValue.length > 0) {
          <div class="slider-bar">
            <div class="controls">
              @if (!animationIsRunning()) {
                <button mat-icon-button class="control" (click)="onPlay()">
                  <fa-icon [icon]="['far', 'play']" size="lg"></fa-icon>
                </button>
              } @else {
                <button mat-icon-button class="control" (click)="onPause()">
                  <fa-icon [icon]="['far', 'pause']" size="lg"></fa-icon>
                </button>
              }
            </div>
            <div class="slider" [class.slider-24h]="timeRange() === 24">
              <ngx-slider
                [(value)]="sliderDate"
                [options]="sliderOptions()"
                (userChange)="onSliderChange($event)"></ngx-slider>
            </div>
          </div>
        }
        <mat-divider></mat-divider>
        <div class="map" id="map"></div>
      </mat-card-content>
    </mat-card>
  </ng-template>
</div>
